import { Star, MapPin, User } from "lucide-react";
import { AnimatedSection } from "@/components/AnimatedSection";

const CommercialTestimonials = () => {
  const testimonials = [
    {
      name: "José Pérez",
      role: "Dueño",
      business: "Minimarket Don José",
      location: "La Florida",
      text: "Después de la mantención bajó nuestra cuenta de luz en $80.000 mensuales. La inversión se pagó sola en 2 meses.",
      rating: 5
    },
    {
      name: "María González",
      role: "Administradora",
      business: "Restaurant El Buen Sabor",
      location: "Ñuñoa",
      text: "Se nos quemaban los congeladores cada 6 meses. Desde que MYCING hizo la normalización, cero problemas. Excelente servicio.",
      rating: 5
    },
    {
      name: "Carlos Muñoz",
      role: "Gerente",
      business: "Farmacia Salud Total",
      location: "Puente Alto",
      text: "Necesitábamos certificación SEC urgente. Vinieron al día siguiente y resolvieron todo en una semana. Profesionales 100%.",
      rating: 5
    }
  ];

  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-industrial-gray via-dark-section/90 to-industrial-gray">
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-accent/20 rounded-full blur-3xl animate-liquid-blob-delayed opacity-20" />
      </div>

      <div className="relative z-10 container mx-auto px-4">
        <AnimatedSection animation="fade-in">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-montserrat font-bold text-white text-center mb-4">
            Lo que Dicen Nuestros Clientes
          </h2>
          <p className="text-lg text-white/70 text-center mb-12">
            Más de 500 locales comerciales confían en nosotros
          </p>
        </AnimatedSection>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8 lg:gap-10 max-w-7xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <AnimatedSection
              key={index}
              animation="slide-up"
              delay={index * 100}
            >
              <div className="backdrop-blur-xl bg-white/10 border-2 border-white/20 rounded-3xl p-8 hover:bg-white/15 transition-all duration-300 hover:scale-105 h-full flex flex-col">
                {/* Rating */}
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                  ))}
                </div>

                {/* Testimonial Text */}
                <p className="text-white/90 italic mb-6 flex-grow leading-relaxed">
                  "{testimonial.text}"
                </p>

                {/* Author Info */}
                <div className="border-t border-white/10 pt-4">
                  <div className="flex items-start gap-3 mb-2">
                    <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary/30 to-primary/10 border-2 border-primary/40 flex items-center justify-center flex-shrink-0">
                      <User className="w-5 h-5 text-primary" />
                    </div>
                    <div>
                      <p className="font-bold text-white">{testimonial.name}</p>
                      <p className="text-sm text-white/60">{testimonial.role}</p>
                    </div>
                  </div>
                  <p className="text-sm text-primary font-medium">{testimonial.business}</p>
                  <div className="flex items-center gap-1 text-xs text-white/50 mt-1">
                    <MapPin className="w-3 h-3" />
                    {testimonial.location}
                  </div>
                </div>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CommercialTestimonials;
